/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Interview_Prepare_Toast_Brief_GeneratedInputs */

const en_interview_prepare_toast_brief_generated = /** @type {(inputs: Interview_Prepare_Toast_Brief_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company brief generated`)
};

const de_interview_prepare_toast_brief_generated = /** @type {(inputs: Interview_Prepare_Toast_Brief_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unternehmensbericht generiert`)
};

const fr_interview_prepare_toast_brief_generated = /** @type {(inputs: Interview_Prepare_Toast_Brief_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fiche entreprise générée`)
};

const es_interview_prepare_toast_brief_generated = /** @type {(inputs: Interview_Prepare_Toast_Brief_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Informe de empresa generado`)
};

const it_interview_prepare_toast_brief_generated = /** @type {(inputs: Interview_Prepare_Toast_Brief_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scheda aziendale generata`)
};

const nl_interview_prepare_toast_brief_generated = /** @type {(inputs: Interview_Prepare_Toast_Brief_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bedrijfsnotitie gegenereerd`)
};

const pl_interview_prepare_toast_brief_generated = /** @type {(inputs: Interview_Prepare_Toast_Brief_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notatka o firmie wygenerowana`)
};

const fi_interview_prepare_toast_brief_generated = /** @type {(inputs: Interview_Prepare_Toast_Brief_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yrityksen tiivistelmä luotu`)
};

const da_interview_prepare_toast_brief_generated = /** @type {(inputs: Interview_Prepare_Toast_Brief_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Firmaoversigt genereret`)
};

const sv_interview_prepare_toast_brief_generated = /** @type {(inputs: Interview_Prepare_Toast_Brief_GeneratedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Företagsöversikt genererad`)
};

/**
* | output |
* | --- |
* | "Company brief generated" |
*
* @param {Interview_Prepare_Toast_Brief_GeneratedInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const interview_prepare_toast_brief_generated = /** @type {((inputs?: Interview_Prepare_Toast_Brief_GeneratedInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Interview_Prepare_Toast_Brief_GeneratedInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_interview_prepare_toast_brief_generated(inputs)
	if (locale === "fr") return fr_interview_prepare_toast_brief_generated(inputs)
	if (locale === "es") return es_interview_prepare_toast_brief_generated(inputs)
	if (locale === "it") return it_interview_prepare_toast_brief_generated(inputs)
	if (locale === "nl") return nl_interview_prepare_toast_brief_generated(inputs)
	if (locale === "pl") return pl_interview_prepare_toast_brief_generated(inputs)
	if (locale === "fi") return fi_interview_prepare_toast_brief_generated(inputs)
	if (locale === "da") return da_interview_prepare_toast_brief_generated(inputs)
	if (locale === "sv") return sv_interview_prepare_toast_brief_generated(inputs)
	return en_interview_prepare_toast_brief_generated(inputs)
});